const contentAccordionEl = document.querySelector('.content-accordion-element');

if (contentAccordionEl) {
  // Получаем исходный HTML
  const originalHTML = contentAccordionEl.innerHTML;

  // Создаем временный контейнер для парсинга
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = originalHTML;

  // Находим все h4 элементы
  const h4Elements = tempContainer.querySelectorAll('h4');

  if (h4Elements.length > 0) {
    // Массив для хранения аккордеон элементов
    const accordionItems = [];

    h4Elements.forEach((h4, index) => {
      // Создаем структуру аккордеон элемента
      const item = document.createElement('div');
      item.className = 'content-accordion-element__item is-active';

      // Создаем заголовок
      const head = document.createElement('div');
      head.className = 'content-accordion-element__head';

      const icon = document.createElement('div');
      icon.className = 'content-accordion-element__icon';
      icon.innerHTML = '<i class="icon-arrow-down"></i>';

      const title = document.createElement('div');
      title.className = 'content-accordion-element__title';
      title.appendChild(h4.cloneNode(true));

      head.appendChild(icon);
      head.appendChild(title);

      // Создаем контент
      const content = document.createElement('div');
      content.className = 'content-accordion-element__content';

      // Собираем все элементы между текущим h4 и следующим h4
      let currentNode = h4.nextSibling;
      const nextH4 = h4Elements[index + 1];

      while (currentNode && currentNode !== nextH4) {
        const nextNode = currentNode.nextSibling;

        // Добавляем только элементы (не текстовые ноды с пробелами)
        if (currentNode.nodeType === Node.ELEMENT_NODE) {
          content.appendChild(currentNode.cloneNode(true));
        } else if (currentNode.nodeType === Node.TEXT_NODE && currentNode.textContent.trim() !== '') {
          content.appendChild(currentNode.cloneNode(true));
        }

        currentNode = nextNode;
      }

      // Собираем элемент только если есть контент
      if (content.children.length > 0 || content.textContent.trim() !== '') {
        item.appendChild(head);
        item.appendChild(content);
        accordionItems.push(item);
      }
    });

    // Заменяем содержимое только если есть элементы аккордеона
    if (accordionItems.length > 0) {
      contentAccordionEl.innerHTML = '';
      accordionItems.forEach(item => {
        contentAccordionEl.appendChild(item);
      });

      // Добавляем обработчики клика после рендера
      initAccordion();
    }
  }
}

// Функция расчета высоты контента
function calculateAccordionHeights() {
  const accordionContents = document.querySelectorAll('.content-accordion-element__content');

  if (accordionContents.length > 0) {
    accordionContents.forEach(content => {
      // Временно убираем ограничения для расчета реальной высоты
      const originalMaxHeight = content.style.maxHeight;
      const originalOverflow = content.style.overflow;

      content.style.maxHeight = 'none';
      content.style.overflow = 'visible';

      // Получаем полную высоту контента
      const contentHeight = content.scrollHeight;

      // Возвращаем стили
      content.style.overflow = originalOverflow;

      // Устанавливаем max-height с запасом +100px
      const maxHeight = contentHeight + 100;
      content.style.maxHeight = originalMaxHeight; // Возвращаем на мгновение для плавности

      // Сохраняем вычисленную высоту в data-атрибут
      content.dataset.calculatedHeight = maxHeight + 'px';

      // Если элемент активен, применяем новую высоту
      const item = content.closest('.content-accordion-element__item');
      if (item && item.classList.contains('is-active')) {
        content.style.maxHeight = maxHeight + 'px';
      }
    });
  }
}

// Функция инициализации аккордеона
function initAccordion() {
  const accordionHeads = document.querySelectorAll('.content-accordion-element__head');

  if (accordionHeads.length > 0) {
    accordionHeads.forEach(head => {
      head.addEventListener('click', function() {
        const item = this.closest('.content-accordion-element__item');

        if (item) {
          const content = item.querySelector('.content-accordion-element__content');
          const isActive = item.classList.contains('is-active');

          if (isActive) {
            // Закрываем
            content.style.maxHeight = '0';
            item.classList.remove('is-active');
          } else {
            // Открываем с вычисленной высотой
            const calculatedHeight = content.dataset.calculatedHeight || '1000px';
            content.style.maxHeight = calculatedHeight;
            item.classList.add('is-active');
          }
        }
      });
    });
  }

  // Первоначальный расчет высоты
  setTimeout(() => {
    calculateAccordionHeights();
  }, 50);
}

// Debounce функция
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Обработчик ресайза с debounce
const handleResize = debounce(() => {
  calculateAccordionHeights();
}, 300);

// Добавляем слушатель ресайза
window.addEventListener('resize', handleResize);